import axiosInstance from "./api";

// Obtener los cupones del usuario. Con eventId, solo los de ese evento más los globales.
export const getCoupons = async (eventId) => {
    try {
        const response = await axiosInstance.get('/coupons', eventId ? { params: { eventId } } : undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Crear un nuevo cupón
export const createCoupon = async (couponData) => {
    try {
        const response = await axiosInstance.post('/coupons', couponData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Actualizar un cupón existente
export const updateCoupon = async (couponCode, couponData) => {
    try {
        const response = await axiosInstance.put(`/coupons/${couponCode}`, couponData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Eliminar un cupón
export const deleteCoupon = async (couponCode) => {
    try {
        const response = await axiosInstance.delete(`/coupons/${couponCode}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Importar cupones desde CSV
export const importCouponsFromCsv = async (importData) => {
    try {
        const response = await axiosInstance.post('/coupons/import-csv', importData);
        return response.data;
    } catch (error) {
        throw error;
    }
};
